import type { CustomThemeConfig } from '@iheartjane/reefer';

import { posTypographyVariants, posVariantComponentMap } from './posTypography';

export const defaultTheme: CustomThemeConfig = {
  borderRadius: {
    xl: '64px',
  },
  components: {
    Button: {
      icons: {
        sizes: {
          default: {
            borderRadius: 'xl',
            height: 64,
          },
          jumbo: {
            borderRadius: 'xl',
            height: 84,
          },
          large: {
            height: 80,
          },
          small: {
            height: 40,
          },
        },
      },
      sizes: {
        default: {
          borderRadius: 'sm',
          height: 64,
          paddingX: 24,
          typographyVariant: 'body-bold',
        },
        jumbo: {
          borderRadius: 'xl',
          height: 120,
          paddingX: 48,
          typographyVariant: 'title-bold',
        },
        large: {
          borderRadius: 'sm',
          height: 80,
          paddingX: 32,
          /** @todo should be section, but this requires making button typography generic */
          typographyVariant: 'header-bold',
        },
        small: {
          borderRadius: 'xs',
          height: 48,
          paddingX: 16,
          typographyVariant: 'mini-bold',
        },
      },
    },
    Icon: {
      sizes: {
        lg: '32px',
        md: '24px',
        sm: '16px',
        xl: '48px',
        xxl: '64px',
        xxxl: '80px',
      },
    },
    Typography: {
      componentMapping: posVariantComponentMap,
      fonts: {},
      variants: posTypographyVariants,
    },
  },
};
